import * as React from 'react'
import { Link, browserHistory } from 'react-router'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../stores/CurrentCompanyStore'
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap'
import { EmployeeNavbar } from './EmployeeNavbar'
import { Routes } from '../../constants/Routes'
import { BlazeButton } from '../../components/CustomButtons/BlazeButton'
import { CashCounterModal } from './CashCount/CashCounterModal'
import BlazeLogo from '../../images/logos/blaze-branding-logo.svg'
import Logo from '../../images/logos/greenline-new-logo.svg'
import { message } from 'antd-v4'
import { Icon } from 'antd'
import { isDev, parseErrorMsg } from '../../utilities/helpers'
import { POSStore } from '../../stores/POSStore'
import { THEME_COLORS } from '@getgreenline/shared'
import { BlazeAlert } from '../../components/BlazeAlert/BlazeAlert'
import { captureError } from '../../utilities/logging'
import { ShiftModels } from '@getgreenline/shifts'
interface Props {
  currentCompanyStore?: CurrentCompanyStore
  posStore?: POSStore
}

interface State {
  collapsed: boolean
  isCashCounterModalVisible: boolean
  menuExpanded: boolean
  createEndShift: ShiftModels.CreateEndShift
}

function getSelectedStyleFromUrl(searchString: string): any {
  const url = window.location.pathname.toLowerCase()
  searchString = searchString.toLowerCase()
  return url.includes(searchString) ? { color: 'white' } : { color: 'gray' }
}

@inject('currentCompanyStore', 'posStore')
@observer
export class POSNavbar extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      collapsed: true,
      isCashCounterModalVisible: false,
      menuExpanded: false,
      createEndShift: new ShiftModels.CreateEndShift(),
    }
  }

  UNSAFE_componentWillReceiveProps() {
    this.setState({ collapsed: true })
  }

  setIsCashCounterModalVisible = (isCashCounterModalVisible: boolean) =>
    this.setState({ isCashCounterModalVisible })

  setMenuExpanded = (menuExpanded: boolean) => this.setState({ menuExpanded })

  onEndShiftClick = () => {
    this.setIsCashCounterModalVisible(true)
    this.setMenuExpanded(false)
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }

  endShift = async (passcodeValue?: string) => {
    try {
      this.state.createEndShift.setRegisterPasscode(passcodeValue || '')
      const endedShift = await this.props.posStore!.endShift(this.state.createEndShift)
      browserHistory.push(Routes.POS_SALE(`?lastShiftId=${endedShift.id}`))
      window.location.reload()
    } catch (error) {
      message.error(parseErrorMsg(error) || 'There was an error finishing this shift')
    } finally {
      this.setState({ isCashCounterModalVisible: false })
    }
  }

  onCancel = () => {
    this.state.createEndShift.setRegisterPasscode('')
    this.setState({ isCashCounterModalVisible: false })
  }

  render() {
    const company = this.props.currentCompanyStore!.company!
    const posStore = this.props.posStore
    const saleStyle = getSelectedStyleFromUrl('pos/sale')
    const paymentsStyle = getSelectedStyleFromUrl('pos/payments')
    const customersStyle = getSelectedStyleFromUrl('pos/customers')
    const settingsStyle = getSelectedStyleFromUrl('pos/settings')

    const defaultIconStyles = { width: 14, height: 14 }

    return (
      <Navbar
        className='text-white'
        fixed='top'
        expand={'xs'}
        style={{ backgroundColor: THEME_COLORS.BRAND.black, zIndex: 1 }}
      >
        <NavbarBrand
          style={{ color: 'inherit' }}
          onClick={() => this.setMenuExpanded(!this.state.menuExpanded)}
        >
          <span className='fa fa-bars ml-2 text-white' />
        </NavbarBrand>
        <NavbarToggler onClick={() => this.toggleNavbar()} style={{ color: 'white' }}>
          <span className='fa fa-navicon mt-1' />
        </NavbarToggler>
        <li className='nav-item active' style={{ listStyle: 'none' }}>
          <EmployeeNavbar />
        </li>

        {posStore?.isCurrentShiftLong && (
          <div onClick={() => this.setIsCashCounterModalVisible(true)}>
            <BlazeAlert type='warning' showIcon>
              Your shift is running longer than 24 hours, please end this shift.
            </BlazeAlert>
          </div>
        )}

        <Collapse isOpen={!this.state.collapsed} navbar>
          <Nav className='ml-auto pos-navbar' navbar>
            <NavItem>
              <NavLink tag={Link} to={Routes.POS_SALE()} style={saleStyle}>
                Register
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink tag={Link} to={Routes.POS_PAYMENTS} style={paymentsStyle}>
                Sales
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink tag={Link} to={Routes.POS_VIEW_CUSTOMERS} style={customersStyle}>
                Customers
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink tag={Link} to={Routes.POS_SETTINGS} style={settingsStyle}>
                Settings
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink onClick={() => this.setState({ isCashCounterModalVisible: true })}>
                <BlazeButton
                  buttonProps={{
                    type: 'danger',
                    // Button appears to be slightly higher than the rest. Adjust accordingly
                    style: { bottom: -2 },
                    onClick: this.onEndShiftClick,
                  }}
                  titleProps={{
                    title: 'End shift',
                  }}
                />
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>

        {this.state.menuExpanded && (
          <div
            id='pos-menu'
            className='background-shadow animated slideInLeft'
            style={
              {
                backgroundColor: THEME_COLORS.BRAND.blazeBlackSideNav,
                position: 'fixed',
                top: 0,
                left: 0,
                width: 300,
                height: '100vh',
                VendorAnimationDuration: '0.2s',
              } as any
            }
          >
            <div className='pt-4 pr-4 pb-4'>
              <img className='ml-3' alt='' src={Logo} style={{ width: 124, height: 28 }} />
              <a className='pull-right' onClick={() => this.setMenuExpanded(false)}>
                <span className='fa fa-times text-white' />
              </a>
            </div>
            <Link
              to={Routes.POS_SALE()}
              className='text-white'
              onClick={() => this.setMenuExpanded(false)}
            >
              <div className='p-4'>
                <span className='fa fa-money mr-3' />
                POS register
              </div>
            </Link>
            <Link
              to={Routes.POS_PAYMENTS}
              className='text-white'
              onClick={() => this.setMenuExpanded(false)}
            >
              <div className='pb-4 pt-4'>
                <Icon type='dollar' className='mr-3 ml-4' style={defaultIconStyles} />
                Sales
              </div>
            </Link>
            <Link
              to={Routes.POS_VIEW_CUSTOMERS}
              className='text-white'
              onClick={() => this.setMenuExpanded(false)}
            >
              <div className='pt-4 pb-4'>
                <Icon type='idcard' className='mr-3 ml-4' style={defaultIconStyles} />
                Customers
              </div>
            </Link>
            <Link
              to={Routes.POS_SETTINGS}
              className='text-white'
              onClick={() => this.setMenuExpanded(false)}
            >
              <div className='pt-4 pb-4'>
                <Icon type='setting' className='mr-3 ml-4' style={defaultIconStyles} />
                Settings
              </div>
            </Link>

            <a className='text-white' onClick={this.onEndShiftClick}>
              <div className='p-4'>
                <span className='fa fa-power-off mr-3' />
                End shift
              </div>
            </a>
            <Link to='/' className='text-white' onClick={() => this.setMenuExpanded(false)}>
              <div className='p-4'>
                <span className='fa fa-sign-in mr-3' />
                Back to login page
              </div>
            </Link>

            <div>
              <Link to={{ pathname: 'https://blaze.me' }} target='_blank'>
                <img
                  className='ml-4 mt-4'
                  alt=''
                  src={BlazeLogo}
                  style={{ width: 75, height: 14 }}
                />
              </Link>
            </div>

            {isDev(company.id) && (
              <div
                className='mt-4 p-4 cursor-pointer'
                onClick={() => captureError('Sentry error test', new Error('Sentry error test'))}
              >
                <span className='fa fa-flask mr-3' />
                Test Sentry error
              </div>
            )}
          </div>
        )}

        <CashCounterModal
          titlesFor={{
            modal: 'Float count',
            skipMessage: 'Count later',
            passwordMessage: 'End your shift',
            passwordButton: 'End shift',
          }}
          descriptionsFor={{
            skipMessage: 'Float counts can be added on the Dashboard',
            passwordMessage: 'You can print your end-of-shift receipt after ending',
          }}
          visible={this.state.isCashCounterModalVisible}
          onSuccess={this.endShift}
          cashCountObject={this.state.createEndShift}
          onCancel={this.onCancel}
          hasPassword
        />
      </Navbar>
    )
  }
}
